import React, { Fragment } from 'react';
import { Table, Button, ButtonToolbar, Panel } from 'react-bootstrap';
import PropTypes from 'prop-types';

// Helpers ------------------------------------------------------
const inboxImapUri = ({ssl, hostname, port}) =>
  `${ssl ? 'imap+ssl' : 'imap'}://${hostname}:${port}`;

// --------------------------------------------------------------

export default function ECFMailboxesList({
  config,
  onConnectNewExternalInboxRequested,
  onDisconnectExternalInboxRequested,
  onEditExternalInboxRequested,
}) {

  const typeToLabel = label => ({
    gmail:   'GMail',
    hotmail: 'HotMail',
    imap:    'IMAP',
  }[label] || 'Unknown');

  const InboxDetails = ({ inbox }) => {
    if (inbox.type === 'imap') return (
      <span>
        <strong>{inbox.connection_secrets.username}</strong>
        {''} <em>via</em> {''}
        <strong>{inboxImapUri(inbox.connection_settings)}</strong>
      </span>
    );
    // Gmail, Hotmail, etc just show username
    return <strong>{inbox.connection_secrets.username}</strong>;
  }

  const InboxActions = ({ inbox }) => (
    <ButtonToolbar>
      <Button
        bsStyle="link"
        bsSize="xs"
        onClick={() => onEditExternalInboxRequested(inbox) }
      >
        <i className="fa fa-gear" />{ ' ' }
        Update Credentials
      </Button>

      <Button
        bsStyle="link"
        bsSize="xs"
        onClick={
          () => confirm(`
              Are you sure you wish to disconnect ${typeToLabel(inbox.type)} connection?
              (Messages already received will not be removed from CourtDrive)
            `) && onDisconnectExternalInboxRequested(inbox)
        }
        style={{ color: 'red' }}
      >
        <i className="fa fa-unlink" />{ ' ' }
        Disconnect
      </Button>

    </ButtonToolbar>
  );


  const managedInbox    = config.managed;
  const externalInboxes = config.external;

  const hasExternalInbox = externalInboxes.length > 0;

  if (!managedInbox) return (
    <Panel>
      <Panel.Heading>
        <Panel.Title>
          Your CourtDrive Email
        </Panel.Title>
      </Panel.Heading>
      <Panel.Body>
        <Button
          bsStyle="primary"
          onClick={ () => window.open('/ecf/register') }
        >
          Click Here To Setup your CourtDrive Email
        </Button>
      </Panel.Body>

    </Panel>
  );

  return (
  <Fragment>
    <Panel>
      <Panel.Heading>
        <Panel.Title>
          <Button
            bsStyle="link"
            bsSize="xs"
            onClick={() => window.open('https://support.courtdrive.com/hc/en-us/sections/200908778-ECF-Email-Manager')}
            style={{float: 'right', color: 'navy', textDecoration: 'underline'}}
            href="#">Instructions to add to court</Button>
          Your CourtDrive Email
        </Panel.Title>
      </Panel.Heading>
      <Panel.Body>
        <h2>{managedInbox.prefix}@ecf.courtdrive.com</h2>
      </Panel.Body>

    </Panel>

    <Panel>
      <Panel.Heading>
        <Panel.Title>
          <Button
            style={{float:'right'}}
            bsStyle={ 'primary' }
            bsSize="xs"
            onClick={onConnectNewExternalInboxRequested}
          >
            <i className="fa fa-link" /> {''}
            Connect {hasExternalInbox ? 'another' : 'an' } external mailbox
          </Button>
          Connect External Mailboxes (GMail, Hotmail, IMAP)
        </Panel.Title>
      </Panel.Heading>
      <Panel.Heading style={{ backgroundColor: '#fcf8e3' }}>
        <i className="fa fa-info-circle" />
        { ' ' }
        Use this option if you cannot add your CourtDrive email as a secondary notice recipient.
        <br />
        {/* invisible icon of same size for alignment */}
        <i className="fa fa-exclamation-triangle" styl={{ visibility: 'hidden' }} />
        { ' ' }
        Please designate this inbox for ECF notices only and provide the email address only to the courts.
      </Panel.Heading>
      <Panel.Body>
        <Table>
          <thead>
            <tr>
              <th>Inbox Type</th>
              <th>Details</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            { externalInboxes.length === 0 &&
            <tr>
              <td colSpan="3">
                No mailboxes have been configured.
              </td>
            </tr>}
            { externalInboxes.map(inbox => (
              <tr>
                <td>{typeToLabel(inbox.type)}</td>
                <td>{InboxDetails({ inbox })}</td>
                <td>{InboxActions({ inbox })}</td>
              </tr>
            )) }
          </tbody>
        </Table>

      </Panel.Body>

    </Panel>
  </Fragment>)
}

ECFMailboxesList.propTypes = {
  config: PropTypes.object.isRequired,
  // Callbacks
  onConnectNewExternalInboxRequested: PropTypes.func.isRequired,
  onDisconnectExternalInboxRequested: PropTypes.func.isRequired,
  onEditExternalInboxRequested:       PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/User/ECFMailboxes/ECFMailboxesList.jsx